export default{
  people:[
    {
      id: 0,
      name: 'LONGIN TOMASZEWSKI',
      books: [
        'Kronika Wileńska 1939-1941. Wydawnictwo POMOST. Warszawa 1989.',
        'Kronika Wileńska 1941-1945. Z dziejów Polskiego Państwa Podziemnego. Oficyna Wydawnicza POMOST Warszawa 1992.',
        'Kronika Wileńska 1939-1941. Wydawnictwo POMOST. Wydanie III, poszerzone i uzupełnione. Warszawa 1994.',
        'Wileńszczyzna lat wojny 1939-1945. Oficyna Wydawnicza RYTM. Warszawa 1999.',
        'Współdziałania Okręgowej Delegatury Rządu i Stronnictw Politycznych z Armią Krajową w walce o wyzwolenie Wileńszczyzny. Biblioteka „Kuriera Wileńskiego”. Sympozjum historyczne, „Rok 1944 na Wileńszczyźnie” .Wilno 30.06 i 01.07.1994 r.'
      ]
    },
    {
      id: 1,
      name: 'ROMAN KORAB-ŻEBRYK',
      books: ['Operacja Wileńska A K. Państwowe Wydawnictwo Naukowe. Warszawa 1988.Wydanie II.']
    },
    {
      id: 2,
      name: 'EDMUND BANASIKOWSKI',
      books: ['Na zew ziemi wileńskiej. Editions Spotkania. Warszawa –Paryż 1990.']
    },
    {
      id: 3,
      name: 'JAROSŁAW WOŁKONOWSKI',
      books: ['Okręg Wileński Związku Walki Zbrojnej Armii Krajowej w latach 1939-1945. Oficyna Wydawnicza „ADIUTOR” Wilno-Warszawa, 1996.']
    },
    {
      id: 4,
      name: 'TADEUSZ SZYNKOWSKI',
      books: ['BŁYSKAWICA” na ziemi wileńskiej. Wydawnictwo Polskie w Wilnie. Biblioteka Magazynu Wileńskiego.']
    },
    {
      id: 5,
      name: 'JANUSZ BOHDANOWICZ',
      books: [
        'Konspiracja i walki zbrojne na Wileńszczyźnie i epilog. Gdańsk, 1990. Broszura. Kserokopia.',
        'Życiorysy Dowódców i Kalendaria działalności Brygad. Gdańsk 1989. Broszura. Kserokopia.'
      ]
    },
    {
      id: 6,
      name: 'KRZYSZTOF A. TOCHMAN',
      books: ['Adam Boryczka. Z dziejów WIN-u. Obywatelskie Stowarzyszenie „OSTOJA”. Zwierzyniec - Rzeszów 1999 tom I, 2001 tom II.']
    },
    {
      id: 7,
      name: 'OTTO TEODOR SAWICKI',
      books: ['Album 6. Dyspozycyjnej Brygady AK.']
    },
    {
      id: 8,
      name: 'ROMUALD WARAKOMSKI',
      books: ['Komórka Legalizacyjna Sztabu Okręgu Wileńskiego Armii Krajowej w latach 1939 - 1947. Towarzystwo Miłośników Wilna i Ziemi Wileńskiej Oddz. Bydgoszcz. 1996.']
    },
    {
      id: 9,
      name: 'JAN BARADYN-ŻYLIŃSKI',
      books: ['Ojczyźnie i Przysiędze Hipokratesa Zawsze Wierni. Wydawnictwo TAKT. Kielce 1997.']
    },
    {
      id: 10,
      name: 'ADAM WALCZAK',
      books: ['13. Brygada Armii Krajowej Okręgu Wileńskiego. Wydanie kserograficzne.Toruń 1984.']
    },
    {
      id: 11,
      name: 'KAZIMIERZ KRAUZE',
      books: ['Ostatni raport. Wileński Przekaz Nr 8 - 12. Okręg Wileński Środowisko w Gdańsku Światowy Związek Żołnierzy Armii Krajowej. Rok 1991.']
    },
    {
      id: 12,
      name: 'WIKTOR SADOWSKI',
      books: ['12. Brygada w pamięci partyzantów. Wileński przekaz Nr 3 - 5. Okręg Wileński Środowisko w Gdańsku Światowy Związek Żołnierzy Armii Krajowej. Rok 1993.']
    },
    {
      id: 13,
      name: 'INSTYTUT STUDIÓW POLITYCZNYCH POLSKIEJ AKADEMII NAUK',
      books: ['Katyń. Dokumenty ludobójstwa. Dokumenty i materiały archiwalne przekazane Polsce 14.10.1992 r. Warszawa 1992. Wydawca Instytut Studiów Politycznych.']
    },
    {
      id: 14,
      name: 'TATIANA CARIEWSKAJA, ANDRZEJ CHMIELARZ, ANDRZEJ PACZKOWSKI, EWA ROSOWSKA, SZYMON RUDNICKI',
      books: ['Teczka Specjalna J.W. Stalina. Raporty NKWD z Polski 1944 - 1946. Instytut Studiów Politycznych Polskiej Akademii Nauk. Instytut Historyczny Uniwersytetu Warszawskiego. Oficyna Wydawnicza RYTM. Warszawa 1998.']
    }
  ]
}



// WEBPACK FOOTER //
// ./src/models/historia/bibliografia.js